import { ValidationError } from "../errors";
import { serializerExtensions, SerializerExtensions } from "../extensions";
import { Serializer } from "../serializer";

export const array = <T>(
  elementSerializer: Serializer<T>,
): Serializer<T[]> & SerializerExtensions<T[]> => ({
  serialize: (items) => items.map(elementSerializer.serialize),
  deserialize: (items) => {
    if (!Array.isArray(items)) throw new ValidationError("Value is not an array");
    return items.map(elementSerializer.deserialize);
  },
  ...serializerExtensions(),
});
